module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/modal//egg-bg.png?v=66f67ff2";